import React, { ReactNode } from "react";

export default function({ children }: { children: ReactNode }) {
    return (
        <div className="card__menu">
            {children}
        </div>
    )
}